<div class="breadcrumb mt-4 wrapper wrap" role="menu" attr.aria-label="breadcrumbs"
  [ngClass]="{'breadcrumb-hide': hideBreadcrumbs}">
  <div *ngFor="let breadcrumb of breadcrumbs; let i = index" routerLinkActive="router-link-active" class="row"
    [ngClass]="{'breadcrumb-visited': breadcrumb.visited}" attr.aria-label="{{ 'breadcrumb.label' }}">
    <span class="breadcrumb__inner">
      <span> {{breadcrumb.label}} ({{i + 1}} of {{breadcrumbs.length}})</span>
    </span>
  </div>
</div>